// src/App.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from './hooks/useAuth';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import EditorPage from './pages/EditorPage';

const App = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const previewData = urlParams.get('page');
  const previewId = urlParams.get('id');

  const [currentPage, setCurrentPage] = useState('login');
  const [currentEditPage, setCurrentEditPage] = useState(null);
  const { user, checkAuthStatus } = useAuth();

  useEffect(() => {
    if (previewData || previewId) {
      // 预览模式，不处理（可后续加 PreviewPage）
      return;
    }
    checkAuthStatus().then(authenticated => {
      if (authenticated) {
        setCurrentPage('dashboard');
      }
    });
  }, []);

  const handleLoginSuccess = () => {
    setCurrentPage('dashboard');
  };

  if (previewData || previewId) {
    // TODO: 可添加 PreviewPage
    return <div>预览模式（未实现）</div>;
  }

  if (!user && currentPage === 'login') {
    return <LoginPage onLoginSuccess={handleLoginSuccess} />;
  }

  switch (currentPage) {
    case 'editor':
      return (
        <EditorPage
          currentEditPage={currentEditPage}
          onBack={() => setCurrentPage('dashboard')}
          onSaveSuccess={() => setCurrentPage('dashboard')}
        />
      );
    case 'dashboard':
    default:
      return (
        <DashboardPage
          onCreateNew={() => {
            setCurrentEditPage(null);
            setCurrentPage('editor');
          }}
          onEditPage={(page) => {
            setCurrentEditPage(page);
            setCurrentPage('editor');
          }}
        />
      );
  }
};

export default App;